'use client'

import { Search } from 'lucide-react'

/**
 * Search-bar-shaped trigger for the sitewide command palette (the nav's
 * PaletteLauncher listens for this event and owns the palette itself).
 */
export function ExamSearchTrigger() {
  return (
    <button
      type="button"
      aria-label="Search your exam or credential"
      aria-haspopup="dialog"
      onClick={() => window.dispatchEvent(new CustomEvent('ps:open-palette'))}
      className="border-border bg-bg shadow-card hover:border-hint group flex h-12 w-full items-center gap-3 rounded-full border px-4 text-left transition-colors"
    >
      <Search size={16} className="text-hint shrink-0" aria-hidden="true" />
      <span className="text-hint group-hover:text-body flex-1 truncate text-[15px] transition-colors">
        Search your exam or credential
      </span>
      <kbd
        aria-hidden="true"
        className="border-border bg-surface text-hint hidden rounded-md border px-1.5 py-0.5 text-[11px] font-medium [@media(pointer:fine)]:block"
      >
        ⌘K
      </kbd>
    </button>
  )
}
